<template>
  <td
    class="text-end "
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
    scope="row"
  >
    {{ index + 1 }}
  </td>
  <td
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
  >
    {{ item.name }}
  </td>
  <td
    :class="[item.inventory_lot_id? 'bg-danger-subtle text-danger': ' text-success']"
  >
    <span
      v-if="item.inventory_lot_id"
      style="
        height: 25px !important;
        font-size: 14px;
      "
    >
      {{ item.lot_number }}
    </span>
    <span
      class=""
      style="
        height: 25px !important;
        font-size: 14px;
      "
      v-else
    >
      {{ '[ '+$t('New Lot Auto-Create')+' ]' }}
    </span>
  </td>
  <td
    class="text-end"
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
  >
    {{ item.inventory_lot_id? item.remaining_quantity: '-' }}
  </td>
  <td
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
  >
  <div class="input-group-sm ">
    <input
      type="number"
      inputmode="decimal"
      v-model.number="v$.item.quantity.$model"
      class=" form-control shadow-none text-end"
      :class="[item.inventory_lot_id? 'border-danger text-danger': 'border-success text-success']"
      style="
        height: 25px;
        font-size: 14px;
      "
      :placeholder="$t('Enter quantity') + '...'"
      :disabled="$parent.type === 'EDIT' && $parent.state !== 'draft'"
    >
    <div v-for="error of v$.item.quantity.$errors"
      class="d-block invalid-feedback"
      :key="error.$uid"
    >
      {{ error.$message }}
    </div>
  </div>
  </td>
  <td
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
  >
    {{ $t(item.unit_name) }}
  </td>
  <td
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
  >
    <input
      type="text"
      class="form-control shadow-none"
      style="
        height: 25px;
        font-size: 14px;
      "
      v-model.trim="v$.item.reason_detail.$model"
      :placeholder="$t('Enter optional') + '...'"
      :disabled="$parent.type === 'EDIT' && $parent.state !== 'draft'"
    >
  </td>
  <td
    class="text-end"
    :class="[item.inventory_lot_id? 'bg-danger-subtle': '']"
  >
    <i
      v-if="$parent.type === 'CREATE' || $parent.state == 'draft'"
      @click="$parent.deleteItem(index)"
      class="fa-solid fa-trash text-danger"
      style="cursor: pointer;"
    />
  </td>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-item";
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.item)
  },
  props: {
    item: {
      type: Object,
      default: [{
        inventory_id: '',
        inventory_lot_id: '',
        unit_id: '',
        name: '',
        lot_number:'',
        unit_name: '',
        remaining_quantity: '',
        quantity: '',
        cost: 0,
        conversion_factor: 1,
        total_cost: '',
        reason_detail: ''
      }]
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    let vm = this;
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
  },
  async mounted() {},
  computed: {
  },
  watch: {
    "item.quantity" (nval, oval) {
      if (nval === oval) return;

      if (this.item.inventory_lot_id !== '' && (nval !== null && nval !== '')) {
        const absVal = -Math.abs(nval);
        if (this.item.quantity !== absVal) {
          this.$nextTick(() => {
            this.item.quantity = absVal;
          });
        }
      }
      this.item.total_cost = Math.abs(nval) * this.item.cost;
    },
  }
}
</script>
